module.exports = __webpack_public_path__ + "static/media/master_active.954e73f8.png";